import { render } from "./CalculateDiscount.vue?vue&type=template&id=495e4219&scoped=true"
import script from "./CalculateDiscount.vue?vue&type=script&lang=js"
export * from "./CalculateDiscount.vue?vue&type=script&lang=js"

import "./CalculateDiscount.vue?vue&type=style&index=0&id=495e4219&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495e4219"]])

export default __exports__